import './index.css'
import {StrictMode} from 'react'
import {hydrateRoot} from 'react-dom/client'
import {App} from './App.tsx'
import {BrowserRouter as Router} from 'react-router-dom'
import {Provider} from 'react-redux'
// import {PersistGate} from 'redux-persist/integration/react'
import {store} from './utils/storage/stores/store.ts'
// import {persistor} from './utils/storage/stores/persistor.ts'
import './oldStyles.css'

// createRoot(document.getElementById('root')!).render(
//     <StrictMode>
//         <Provider store={store}>
//             <PersistGate loading={null} persistor={persistor}>
//                 <Router>
//                     <App/>
//                 </Router>
//             </PersistGate>
//         </Provider>
//     </StrictMode>,
// );

hydrateRoot(document.getElementById('root')!,
    <StrictMode>
        <Provider store={store}>
            <Router>
                {/*<PersistGate loading={null} persistor={persistor}>*/}
                    <App/>
                {/*</PersistGate>*/}
            </Router>
        </Provider>
    </StrictMode>
);
